
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if (items){
    ; __append("\n<div class=\"c-related\">\n    <div class=\"related\">\n        <div class=\"re-title\">\n            <h3>相关推荐</h3>\n        </div>\n        <div class=\"re-box\">\n            <div class=\"re-list ")
    ;  if (items.length == 0) {
    ; __append("noNews")
    ;  }
    ; __append("\">\n                ")
    ;  if (items.length >0) {
    ; __append("\n                ")
    ;  for (var i=0;i<items.length;i++){
    ; __append("\n                <div class=\"re-item clearfix ")
    ; if (i == (items.length-1)) {
    ; __append(" mb0")
    ; }
    ; __append("\">\n                    <div class=\"re-image fl\">\n                        <a href=\"")
    ; __append(escape(items[i].link))
    ; __append("\" target=\"_blank\"><img src=\"")
    ; __append(escape(items[i].thumb_new))
    ; __append("\" alt=\"")
    ; __append(escape(items[i].title))
    ; __append("\"></a>\n                    </div>\n                    <div class=\"re-info fr\">\n                        <a href=\"")
    ; __append(escape(items[i].link))
    ; __append("\" class=\"re-detail\" target=\"_blank\">\n                            ")
    ; __append(escape(items[i].title))
    ; __append("\n                        </a>\n                    </div>\n                </div>\n                ")
    ; }
    ; __append("\n                ")
    ; } else {
    ; __append("\n                暂无相关推荐\n                ")
    ;  }
    ; __append("\n            </div>\n        </div>\n\n    </div>\n    <div class=\"client-logo\"><a href ='https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=2644'><img src=\"//p1.ifengimg.com/a/2017/0628/s/live/client.jpg\"></a></div>\n    <!-- <div class=\"adbox\"><a href=\"#\"><img src=\"//c1.ifengimg.com/mappa/2017/02/16/dd7e07e271a77e0634e24f5e8b99c1fa.jpg\" alt=\"\"></a></div> -->\n\n    <!-- <div class=\"logobox\"><a href=\"\"><img src=\"//d.ifengimg.com/w168_h90/p3.ifengimg.com/cmpp/2017/04/10/752e753a13a08a0cbaa405bfcf03b1e8_size30_w168_h120.jpg\" alt=\"\"></a></div> -->\n</div>\n")
    ;  }
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/modules/relatedNews/relatedNews.ejs
// module id = 288
// module chunks = 0